import React from 'react';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';

const Host = styled.div`
  display: flex;
`;

const Text = styled.span`
  display: inline-block;
  margin: 0 ${gutter(1)} 0 ${gutter(2)};
`;

interface BreadcrumbsProps {
  children: React.ReactNode;
}

export const Breadcrumbs = ({ children }: BreadcrumbsProps) => {
  const items = React.Children.toArray(children).reduce(
    (acc: any[], child: any, index, array) => {
      acc.push(React.cloneElement(child, { key: index }));

      if (index !== array.length - 1) {
        acc.push(<Text key={`separator-${index}`}>/</Text>);
      }

      return acc;
    },
    []
  );
  return <Host>{items}</Host>;
};
